import type {RootContent} from 'hast'

import {HIGHLIGHT_SUBSET, type LowlightInstance} from './use-lowlight'

export function renderHastNode(node: RootContent, index: number): React.ReactNode {
  if (node.type === 'text') return node.value
  if (node.type === 'element') {
    const rawClassName = node.properties?.className
    const className = Array.isArray(rawClassName)
      ? rawClassName.join(' ') || undefined
      : typeof rawClassName === 'string'
        ? rawClassName || undefined
        : undefined
    return (
      <span key={index} className={className}>
        {node.children.map((c, i) => renderHastNode(c as RootContent, i))}
      </span>
    )
  }
  return null
}

/**
 * Highlights `code` to React nodes, optionally forcing `language` (otherwise
 * auto-detected against HIGHLIGHT_SUBSET). Returns null when highlighting yields
 * no element children or throws, so callers can fall back to plain text.
 */
export function highlightCodeToNodes(
  lowlight: LowlightInstance,
  code: string,
  language?: string | null,
): React.ReactNode[] | null {
  try {
    const root = language
      ? lowlight.highlight(language, code)
      : lowlight.highlightAuto(code, {subset: HIGHLIGHT_SUBSET})
    if (!root.children.some(n => n.type === 'element')) return null
    return root.children.map((n, i) => renderHastNode(n, i))
  } catch {
    return null
  }
}
